<div class="d-flex flex-column" style="gap: 1rem">
  <div class="vh-30 position-relative">
    @defer {
      <app-graph [data]="requestData"/>
    } @loading (after 100ms) {
      <ogo-spinner [margin]="'7rem 0'"></ogo-spinner>
    }
  </div>

  <div class="vh-30 position-relative">
    @defer {
      <app-graph [data]="bandwidthData"/>
    } @loading (after 100ms) {
      <ogo-spinner [margin]="'7rem 0'"/>
    }
  </div>

  <div class="vh-30 position-relative">
    @defer {
      <app-graph [data]="nbSitesData" />
    } @loading (after 100ms) {
      <ogo-spinner [margin]="'7rem 0'"/>
    }
  </div>
</div>
